import './style/normalize.css'
import './style/Colours.css'
import './style/Page_Layout.css'
import './style/Text.css'
import './style/App.css'
import './style/User_Advice.css'
import './style/Checkbox.css'
import '../Components/Toggle.css'
import {
    Host_Context,
} from '@quiz-buzz/client-common'
import { useSelector } from '@xstate/react'
import { Host_Registration } from '../Host_Registration/Host_Registration'
import { Host_Game_Setup } from '../Host_Game_Setup/Host_Game_Setup'
import { Host_In_Game } from '../Host_In_Game/Host_In_Game'
import { Host_Game_Finished } from '../Host_Finished/Host_Finished'
import { Host_Unverified } from '../Host_Unverified/Host_Unverified'
import { Host_Purchase_Games } from '../Host_Purchase_Games/Host_Purchase_Games'
import '../Help_Tips/Help_Tips.css'
import { Host_Trial_Registration } from '../Host_Trial_Registration/Host_Trial_Registration'
import { Host_Trial_Ended } from '../Host_Trial_Ended/Host_Trial_Ended'
import { Host_State_Name } from '@quiz-buzz/client-common/src/State/Host_State_Machine'
import { AnyEventObject } from 'xstate'
import { host_machine_actor } from './main'
import { Host_Connection_Closed } from '../Host_Connection_Closed/Host_Connection_Closed'
import { Modal_Popup } from '../Modal_Popup/Modal_Popup'

export interface Base_Host_Props {
    send: (event: AnyEventObject) => void
    context: Host_Context,
    state_value: string
}

export function Host_Mode_Content() {

	const host_state_name = useSelector(host_machine_actor, (state) => state.value)
	const is_trial = useSelector(host_machine_actor, (state) => state.context.is_trial)

	return (
        <>
            {(host_state_name === Host_State_Name.registering_host && is_trial) && (
				<Host_Trial_Registration/>
			)}
			{(host_state_name === Host_State_Name.registering_host && !is_trial) && (
				<Host_Registration/>
			)}
			{host_state_name === Host_State_Name.host_game_unverified && (
				<Host_Unverified/>
			)}
			{host_state_name === Host_State_Name.host_purchase_games && (
				<Host_Purchase_Games />
			)}
			{host_state_name === Host_State_Name.host_game_setup && (
				<Host_Game_Setup/>
			)}
			{host_state_name === Host_State_Name.host_in_game && (
				<Host_In_Game/>
			)}
			{host_state_name === Host_State_Name.host_finished && (
				<Host_Game_Finished/>
			)}
			{host_state_name === Host_State_Name.host_trial_ended && (
				<Host_Trial_Ended/>
			)}
			{host_state_name === Host_State_Name.connection_closed && (
				<Host_Connection_Closed/>
			)}
			<Modal_Popup />
        </>
	)
}

export default Host_Mode_Content


